import React from 'react';
import './_button.scss';
import Image1 from '../../../assets/icons/icon-arrow-right-black.svg';
import { LoadingSpinner } from '../../uiElements/loadingSpinner/LoadingSpinner';

const renderClassNames = (props: IButton) => {
  let cN = `c_button c_button--${props.styleType ? props.styleType : 'dark'}`;
  if (props.disabled || props.loading) {
    cN = `${cN} c_button--disabled`;
  }
  const mapped = cN.split(' ').map((c) => c);

  return mapped.join(' ');
};

export type IButton = {
  id?: string;
  text?: string;
  styleType?: 'light' | 'dark';
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  showArrow?: boolean;
  disabled?: boolean;
  href?: string;
  loading?: boolean;
};
const Button = (props: IButton) => {
  const { id, href, onClick, type, text, disabled, loading } = props;
  if ((href?.length || 0) > 0) {
    return <Image1 width={50} height={50} />;
  }
  return (
    <button
      id={id}
      className={renderClassNames(props)}
      disabled={disabled || loading}
      onClick={(e) => {
        if (disabled || loading) {
          // disable POST event
          e.preventDefault();
        }
        if (onClick) {
          onClick();
        }
      }}
      type={type || 'button'}
    >
      <span style={{
        visibility: loading ? 'visible' : 'hidden',
        marginRight: 10,
        }}
      >
        <LoadingSpinner classes={'small'}/>
      </span>
      <span className={'text'}>{text}</span>
    </button>
  );
};

export { Button };
